import React, { useRef, useEffect, useState } from 'react';
import styles from './accordion.module.css';
import parse from 'html-react-parser';
import i18n from '../../../i18n';
import { LANG_AR } from '../../helpers/constant';
const Accordion = ({ question, answer, isOpen, onClick, colorStartIndex, colorPalette }) => {
    const contentRef = useRef(null);
    const [contentHeight, setContentHeight] = useState(0);

    const applyColorsToContent = (node) => {
        if (React.isValidElement(node)) {
            if (node.type === 'i' || node.type === 'strong') {
                const color = colorPalette[colorStartIndex % colorPalette.length];
                colorStartIndex++;
                return React.cloneElement(node, {
                    style: { color, ...node.props.style },
                    children: React.Children.map(node.props.children, applyColorsToContent),
                });
            }
            return React.cloneElement(node, {
                children: React.Children.map(node.props.children, applyColorsToContent),
            });
        }
        return node;
    };

    useEffect(() => {
        if (contentRef.current) {
            setContentHeight(contentRef.current.scrollHeight);
        }
    }, [isOpen]);
    const renderContent = () => {
        const parsedContent = typeof answer === 'string' ? parse(answer) : answer;
        return React.Children.map(parsedContent, applyColorsToContent);
    };

    return (
        <div className={styles.accordion_item}>
            <div
                // className={`${styles.accordion_title} ${isOpen ? styles.open : ''} arab`}
                className={`${styles.accordion_title} ${i18n.language===LANG_AR? 'arab':''} ${isOpen ? styles.open : ''}`}
                onClick={onClick}
            >
                <h3>{question}</h3>
                <svg
                    className={`${styles.icon} ${isOpen ? styles.rotate : ''}`}
                    width="11.333"
                    height="20.777"
                    viewBox="0 0 11.333 20.777"
                >
                    <path
                        id="Path_13951"
                        data-name="Path 13951"
                        d="M56.781,9.425,49.137,1.742A.956.956,0,0,1,50.271.2l9.545,9.543a.878.878,0,0,1,0,1.3l-9.545,9.542A.927.927,0,0,1,48.9,19.382l7.878-8.016C57.492,10.369,57.027,9.4,56.781,9.425Z"
                        transform="translate(-48.77 0)"
                    />
                </svg>
            </div>
            <div
                className={styles.accordion_content_wrapper}
                style={{ maxHeight: isOpen ? `${contentHeight}px` : '0px' }}
            >
                <div className={styles.accordion_content} ref={contentRef}>
               
                    <>{renderContent()}</>
                </div>
            </div>
        </div>
    );
};

export default Accordion;
